






















































import { Component, Prop } from 'vue-property-decorator';
import Vue, { PropType } from 'vue';
import { LessonTestQuestionEntity } from '@/entities/lesson-test-question.entity';
import { UseService } from '@/services/service';
import { LessonTestResultAnswerEntity } from '@/entities/lesson-test-result-answer.entity';
import LessonTestResultAnswerService from '@/services/lesson-test-result-answer.service';
import moment from 'moment';
import CDivider from '@/components/Helper/CDivider.vue';

@Component<QuestionContent>({
  components: { CDivider },
})
export default class QuestionContent extends Vue {
  @Prop({ type: Object as PropType<LessonTestQuestionEntity>, required: true })
  question: LessonTestQuestionEntity;

  @Prop({ type: Boolean })
  hasNext: boolean;

  selected: number = null;

  @UseService(LessonTestResultAnswerService)
  service: LessonTestResultAnswerService;

  answer: LessonTestResultAnswerEntity = null;

  remainSeconds = 0;

  async mounted() {
    this.answer = await this.service.createOne({
      questionId: this.question.id,
    });
    if (this.answer.answerIndex !== null) {
      this.$emit('answered');
    } else {
      const diffTime = moment().diff(moment(this.answer.createdAt), 'seconds');
      this.remainSeconds = this.question.answerTime - diffTime;
      if (this.remainSeconds <= 0) {
        this.$emit('answered');
      } else {
        const interval = setInterval(async () => {
          this.remainSeconds -= 1;
          if (this.remainSeconds === 0) {
            clearInterval(interval);
            if (this.selected) {
              await this.service.updateOne(this.answer.id, {
                answerIndex: this.selected,
              });
            }
            this.$emit('answered');
          }
        }, 1000);
      }
    }
  }

  async submitAnswer() {
    await this.service.updateOne(this.answer.id, {
      answerIndex: this.selected,
    });
    this.$emit('answered');
  }

  get remainTime() {
    return this.remainSeconds;
  }
}
